import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromStaticData from './static-data.reducer';
import * as fromProductTypeReducer from './reducers/product-types.reducer';
import { EffectsModule } from '@ngrx/effects';
import { StaticDataCountriesEffects } from './effects/static-data-countries.effects';
import { StaticDataComplianceEffects } from './effects/static-data-compliance.effects';
import { StaticDataProofOfBankDocumentTypesEffects } from './effects/static-data-proof-of-bank-document-types.effects';
import { StaticDataProofOfAddressDocumentTypesEffects } from './effects/static-data-proof-of-address-document-types.effects';
import { StaticDataAccountTypesEffects } from './effects/static-data-account-types.effects';
import { StaticDataGoogleAPIKeyEffects } from './effects/static-data-google-api-key.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature(fromStaticData.staticDataFeatureKey, fromStaticData.reducers),
    EffectsModule.forFeature([
      StaticDataCountriesEffects,
      StaticDataComplianceEffects,
      StaticDataProofOfBankDocumentTypesEffects,
      StaticDataProofOfAddressDocumentTypesEffects,
      StaticDataAccountTypesEffects,
      StaticDataGoogleAPIKeyEffects
    ])
  ]
})
export class StaticDataModule {}
